/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetOpportunitiesTasksTaskIdOk
 */
export interface GetOpportunitiesTasksTaskIdOk {
    /**
     * description string
     * @type {string}
     * @memberof GetOpportunitiesTasksTaskIdOk
     */
    description: string;
    /**
     * name string
     * @type {string}
     * @memberof GetOpportunitiesTasksTaskIdOk
     */
    name: string;
    /**
     * notification string
     * @type {string}
     * @memberof GetOpportunitiesTasksTaskIdOk
     */
    notification: string;
    /**
     * task_id integer
     * @type {number}
     * @memberof GetOpportunitiesTasksTaskIdOk
     */
    taskId: number;
}

/**
 * Check if a given object implements the GetOpportunitiesTasksTaskIdOk interface.
 */
export function instanceOfGetOpportunitiesTasksTaskIdOk(value: object): value is GetOpportunitiesTasksTaskIdOk {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('notification' in value) || value['notification'] === undefined) return false;
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    return true;
}

export function GetOpportunitiesTasksTaskIdOkFromJSON(json: any): GetOpportunitiesTasksTaskIdOk {
    return GetOpportunitiesTasksTaskIdOkFromJSONTyped(json, false);
}

export function GetOpportunitiesTasksTaskIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOpportunitiesTasksTaskIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'name': json['name'],
        'notification': json['notification'],
        'taskId': json['task_id'],
    };
}

export function GetOpportunitiesTasksTaskIdOkToJSON(json: any): GetOpportunitiesTasksTaskIdOk {
    return GetOpportunitiesTasksTaskIdOkToJSONTyped(json, false);
}

export function GetOpportunitiesTasksTaskIdOkToJSONTyped(value?: GetOpportunitiesTasksTaskIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'name': value['name'],
        'notification': value['notification'],
        'task_id': value['taskId'],
    };
}

